/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CountryRegionCtsmViewModel } from '../models/CountryRegionCtsmViewModel';
import type { CreateOrUpdateStudyDto } from '../models/CreateOrUpdateStudyDto';
import type { GetStudyDto } from '../models/GetStudyDto';
import type { ISaveStatus } from '../models/ISaveStatus';
import type { PatientVisitDto } from '../models/PatientVisitDto';
import type { PendingApprovalStudySummaryViewModel } from '../models/PendingApprovalStudySummaryViewModel';
import type { Region } from '../models/Region';
import type { SiteViewModel } from '../models/SiteViewModel';
import type { Study } from '../models/Study';
import type { StudyExpenseDto } from '../models/StudyExpenseDto';
import type { StudyPatientViewModel } from '../models/StudyPatientViewModel';
import type { StudySummaryTableViewModel } from '../models/StudySummaryTableViewModel';
import type { StudySummaryViewModel } from '../models/StudySummaryViewModel';
import type { TravelOptionViewModel } from '../models/TravelOptionViewModel';
import type { User } from '../models/User';
import type { VisitName } from '../models/VisitName';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class StudyService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns Study
     * @throws ApiError
     */
    public studyGetAllStudies(): Observable<Array<Study>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies',
        });
    }
    /**
     * @param formData
     * @returns ISaveStatus
     * @throws ApiError
     */
    public studyCreate(
        formData?: CreateOrUpdateStudyDto,
    ): Observable<Array<ISaveStatus>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/studies',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @returns PendingApprovalStudySummaryViewModel
     * @throws ApiError
     */
    public studyGetAllPendingApprovalStudies(): Observable<Array<PendingApprovalStudySummaryViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/pendingapproval',
        });
    }
    /**
     * @returns StudySummaryTableViewModel
     * @throws ApiError
     */
    public studyGetStudySummaries(): Observable<Array<StudySummaryTableViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/studysummaries',
        });
    }
    /**
     * @param studyId
     * @returns GetStudyDto
     * @throws ApiError
     */
    public studyGetByStudyId(
        studyId: number,
    ): Observable<GetStudyDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @param formData
     * @returns ISaveStatus
     * @throws ApiError
     */
    public studyUpdate(
        studyId: number,
        formData?: CreateOrUpdateStudyDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/studies/{studyId}',
            path: {
                'studyId': studyId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param studyId
     * @param studyLogoId
     * @returns binary
     * @throws ApiError
     */
    public studyGetLogo(
        studyId: number,
        studyLogoId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/logo/{studyLogoId}',
            path: {
                'studyId': studyId,
                'studyLogoId': studyLogoId,
            },
        });
    }
    /**
     * @param studyId
     * @returns User
     * @throws ApiError
     */
    public studyGetStudyUsers(
        studyId: number,
    ): Observable<Array<User>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/users',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns SiteViewModel
     * @throws ApiError
     */
    public studyGetStudySites(
        studyId: number,
    ): Observable<Array<SiteViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/sites',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns Region
     * @throws ApiError
     */
    public studyGetStudyRegions(
        studyId: number,
    ): Observable<Array<Region>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/regions',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns CountryRegionCtsmViewModel
     * @throws ApiError
     */
    public studyGetStudyCountries(
        studyId: number,
    ): Observable<Array<CountryRegionCtsmViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/countries',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns TravelOptionViewModel
     * @throws ApiError
     */
    public studyGetStudyTravelOptions(
        studyId: number,
    ): Observable<Array<TravelOptionViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/traveloptions',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns StudyPatientViewModel
     * @throws ApiError
     */
    public studyGetStudyPatientData(
        studyId: number,
    ): Observable<Array<StudyPatientViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/patientdata',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns VisitName
     * @throws ApiError
     */
    public studyGetStudyVisitNames(
        studyId: number,
    ): Observable<Array<VisitName>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/visitnames',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns StudyExpenseDto
     * @throws ApiError
     */
    public studyGetStudyExpenseTypes(
        studyId: number,
    ): Observable<Array<StudyExpenseDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/expensetypes',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns StudySummaryViewModel
     * @throws ApiError
     */
    public studyGetStudySummary(
        studyId: number,
    ): Observable<StudySummaryViewModel> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/summary',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns void
     * @throws ApiError
     */
    public studyCloseStudy(
        studyId: number,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/api/studies/{studyId}/close',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @param patientId
     * @returns PatientVisitDto
     * @throws ApiError
     */
    public studyGetStudyPatientVisitNamesWithRequests(
        studyId: number,
        patientId: number,
    ): Observable<Array<PatientVisitDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/studies/{studyId}/patients/{patientId}/visitnames',
            path: {
                'studyId': studyId,
                'patientId': patientId,
            },
        });
    }
}
